import { normalizeResponse, useControlProxy } from 'api/control/useControlProxy';
import permissions from 'api/Apollo/permissions';
import { METHOD, PATH } from 'api/control/control-api';

function extractIntegrationsFromData(data) {
  if (!Array.isArray(data?.integrations)) {
    return [];
  }

  return data.integrations;
}

export { extractIntegrationsFromData };

function useGetIntegrations(options = {}) {
  // Nix confirmed control api doesn't have an integrations permission and
  // this endpoint is gated by the readPipeline permission
  const [call, response] = useControlProxy({ permission: permissions.readPipeline, ...options });

  const getIntegrations = ({ clusterId, body }) => {
    return call({
      path: PATH.Integrations,
      method: METHOD.GET,
      body: { ...body },
      clusterId,
    });
  };

  const normalizedResponse = normalizeResponse(response, extractIntegrationsFromData);

  return [getIntegrations, normalizedResponse];
}

export default useGetIntegrations;
